// This file is auto-generated by @hey-api/openapi-ts
import { createClient, createConfig, } from "./client";
export const client = createClient(createConfig({
    baseUrl: "https://core-api.staging.v2.citylytics.se",
}));
